export const offboardingOverview = (userId: string) => `/offboarding/${userId}`;
export const offboardingLinkIdentity = (userId: string, tool: string) =>
  `/offboarding/${userId}/tools/${tool}/identity`;
export const offboardingActions = (userId: string) => `/offboarding/${userId}/actions`;
export const offboardingAuditLogs = '/offboarding/audit-logs';
export const offboardingEmployees = '/offboarding/employees';
export const offboardingEmployeeSearch = '/offboarding/employees/search';
export const offboardingEmployee = (userId: string) => `/user/${userId}`;